import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { StagingBanner } from "@/components/system/StagingBanner";
import { GlobalSearchHost } from "./GlobalSearch";

export function AppShell() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {/* Banner only renders on non-prod builds; prod is invisible */}
      <StagingBanner />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      {/* Global ⌘K search — modal lives at the shell so it overlays
          every page; trigger button is rendered inside TopBar. */}
      <GlobalSearchHost />
    </div>
  );
}
